export default __webpack_public_path__ + "static/media/execute_complexity.ed63da5e.png";